export default __webpack_public_path__ + "static/media/5459.18decb93.png";